import React from "react";
import { Link } from "react-router-dom";

import { useAppContext } from "../libs/contextLib";

import "./Home.css";
import logo from "../static/images/tksl-logo.png";

export default function Home() {
  const { isAuthenticated } = useAppContext();

  return (
    <div className="Home">
      <div className="lander">
        <img alt="" src={logo} className="d-inline-block align-top" />{" "}
      </div>
    </div>
  );
}
